import Agent from "infrastructure/agent";

export const getUsers = () => Agent.get("/user");

export const updateUser = (userId, user) => Agent.put(`/user/${userId}`, user);

export default {
  getUsers,
  updateUser,
};
